module.exports = __webpack_public_path__ + "img/8.f4aa1300.png";